module.exports = __webpack_public_path__ + "static/image/history/pc/202308.jpg?0e12790b";